var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rank-content"},[_c('el-tabs',{attrs:{"type":"card"},on:{"tab-click":_vm.handleClick},model:{value:(_vm.ShortTab),callback:function ($$v) {_vm.ShortTab=$$v},expression:"ShortTab"}},[_c('el-tab-pane',{attrs:{"label":"电商达人销量榜","name":"first"}},[_c('DsSalesRankModule')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }